export enum LibraryExportType {
  COMPONENT = 'COMPONENT',
  FIXED_FEE_COMPONENT = 'FIXED_FEE_COMPONENT',
  FIXED_FEE_COMPONENT_NO_ROLES = 'FIXED_FEE_COMPONENT_NO_ROLES',
  FIXED_FEE_DELIVERABLE = 'FIXED_FEE_DELIVERABLE',
  DELIVERABLE_WITH_COMPONENTS = 'DELIVERABLE_WITH_COMPONENTS',
}
